export default "__VITE_ASSET__f96744d0__"